<template>
  <v-card class="background text-center">
    <v-card-title class="headline" primary-title>
      Thank you for using MDKGU e-Services. Rate Us Now !
    </v-card-title>
    <v-card-text>
      If you enjoy using MDKGU e-Services, please take a few seconds to rate your experience with the service. It really helps!

      <div class="text-center mt-2">
        <v-rating :disabled="loading" :readonly="loading" large v-model="rating.value" color="primary"></v-rating>
      </div>
      <div class="mt-3" v-if="rating.value > 0">
        <v-textarea
          autofocus
          outlined
          :disabled="loading"
          :readonly="loading"
          :rules="rating.value < 4 ? [value => !!value || 'This field is required'] : undefined"
          label="We would love to hear if you have some feedback on why you chose that rating *"
          v-model="rating.feedback"
        ></v-textarea>
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="justify-space-between">
      <v-btn text :disabled="loading" @click="submitRating(true)">
        No Thanks
      </v-btn>
      <v-btn
        color="primary"
        text
        :disabled="rating.value === 0 || loading || (rating.value < 4 && rating.feedback.length === 0)"
        @click="submitRating(false)"
      >
        Submit
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from '../axios'
import configuration from '../configurations'

export default {
  name: 'RatingCard',
  props: {
    id: { required: true, type: String }
  },
  data: () => ({
    loading: false,
    rating: { value: 0, feedback: '', reject_rate: false, channel: 'e-Services', reference_no: '', user: { name: '', email: '', phone: '' } }
  }),
  methods: {
    submitRating: async function (reject = false) {
      this.rating.reject_rate = reject
      this.loading = true
      try {
        const db = this.$route.name.replace(/-id/g, '')
        let { data: response } = await axios.post(configuration.WORKER + `/query`, { url: btoa(`/${db === 'feedback' ? 'complaint' : db}/${this.id}`) })
        this.rating.reference_no = response._id
        if (response.complainant) {
          this.rating.user.name = response.complainant.full_name.trim().toUpperCase()
          this.rating.user.email = response.complainant.email.replace(/\s/g, '')
          this.rating.user.phone = response.complainant.phone.replace(/\s/g, '')
        } else {
          this.rating.user.name = response.customer.name.trim().toUpperCase()
          this.rating.user.email = response.customer.email.replace(/\s/g, '')
          this.rating.user.phone = response.customer.phone.replace(/\s/g, '')
        }
        await axios.post(`${configuration.WORKER}/rating`, this.rating)
      } catch (error) {
        this.$store.dispatch('snackbar/setSnackBar', {color: 'error', message: `Failed to submit feedback`, visible: true})
      } finally {
        this.loading = false
        this.$emit('hide', true)
      }
    }
  }
}
</script>
